import React from "react";
// Components
import PersonalDetails from "../sectionWrapper/PersonalDetails";
import TravelDetails from "../sectionWrapper/TravelDetails";
import HealthDetails from "../sectionWrapper/HealthDetails";
import AccommodationDetails from "../sectionWrapper/AccommodationDetails";
import AirTravelDetails from "../sectionWrapper/AirTravelDetails";
import EmergencyContactDetails from "../sectionWrapper/EmergencyContactDetails";
import SectionAutoSaveWrapper from "../../refs/SectionAutoSaveWrapper";
// Assets
import Lock from "../../assets/icons/ic_lock.svg";
import { AiOutlineInfoCircle } from "react-icons/ai"; // example icon

export default function Form({
  showPopup,
  sectionRefs,
  handleAddParticipantTab,
  handleChange,
  formErrors,
  formData,
  onChoiceChange,
  setFormErrors,
  outboundFlights,
  setOutboundFlights,
  inboundFlights,
  setInboundFlights,
  isInvited,
  onKnownUserChange, // ✅ add this
  onCategoryChange,
  allParticipantsData,
  setParticipantOutboundFlights,
  setParticipantInboundFlights,
  fieldRefs,
  inviteFormData,
  setInviteFormData,
  onSectionExit,
}) {
  const userType = localStorage.getItem("userType");
  const isReadOnly = userType === "yes";

  return (
    <div className="">
      <SectionAutoSaveWrapper
        sectionId="section1"
        onSectionExit={onSectionExit}
      >
        <section
          id="section1"
          ref={sectionRefs.section1}
          className="block sm:flex gap-8 justify-between px-4 sm:px-10 py-4 border-b border-sectionBorder"
        >
          <div className="w-full">
            <div className="mb-4">
              <h2 className="">Personal Details</h2>
              <div className="flex items-center gap-1 text-xs text-yellow-800">
                <AiOutlineInfoCircle size={14} className="text-yellow-600" />
                <p className="text-sm">
                  Please enter your first and last name as shown in your
                  passport.
                </p>
              </div>
            </div>
            <PersonalDetails
              formData={formData}
              handleChange={handleChange}
              formErrors={formErrors}
              inputRefs={fieldRefs} // 👈 pass refs here
            />
          </div>
        </section>
      </SectionAutoSaveWrapper>

      <SectionAutoSaveWrapper
        sectionId="section2"
        onSectionExit={onSectionExit}
      >
        <section
          id="section2"
          ref={sectionRefs.section2}
          className="block sm:flex gap-4 justify-between px-4 sm:px-10 py-4 bg-headerLight border-b border-headerBorder"
        >
          <div className="w-full">
            <h2 className="mb-4 w-full">Emergency Contact</h2>
            <EmergencyContactDetails
              formData={formData}
              handleChange={handleChange}
              formErrors={formErrors}
              inputRefs={fieldRefs} // 👈 pass refs here
            />
          </div>
        </section>
      </SectionAutoSaveWrapper>

      <section
        id="section3"
        ref={sectionRefs.section3}
        className="block sm:flex gap-8 justify-between px-4 sm:px-10 py-4 border-b border-sectionBorder"
      >
        <div className="w-full">
          <div className="mb-4">
            <h2 className="">Passport Information</h2>
            {/* <p className="text-[10px] text-yellow-800">
              (Upload or take a photo of your passport to auto-fill your
              details. Please review and confirm them. If any details aren’t
              filled in automatically, enter them manually.)
            </p> */}
          </div>
          <TravelDetails
            formData={formData}
            handleChange={handleChange}
            formErrors={formErrors}
            inputRefs={fieldRefs} // 👈 pass refs here
          />
        </div>
      </section>
      <section
        id="section4"
        ref={sectionRefs.section4}
        className="px-4 sm:px-10 py-4 border-b bg-headerLight border-sectionBorder"
      >
        <h2 className="mb-4">Health Details</h2>
        <HealthDetails
          formData={formData}
          handleChange={handleChange}
          formErrors={formErrors}
          inputRefs={fieldRefs} // 👈 pass refs here
        />
      </section>
      <section
        id="section5"
        ref={sectionRefs.section5}
        className="px-4 sm:px-10 py-4  border-b border-sectionBorder"
      >
        <div className="mb-4">
          <h2>Air Travel Details</h2>
          <div className="flex items-center gap-1 text-xs text-yellow-800">
            <AiOutlineInfoCircle size={14} className="text-yellow-600" />
            <p className="text-sm">
              Please complete this section after purchasing your flight ticket.
            </p>
          </div>
        </div>

        <AirTravelDetails
          outboundFlights={outboundFlights}
          setOutboundFlights={setOutboundFlights}
          inboundFlights={inboundFlights}
          setInboundFlights={setInboundFlights}
          formErrors={formErrors}
          handleChange={handleChange}
          setFormErrors={setFormErrors}
          copyOutBoundFlights={setParticipantOutboundFlights}
          copyInBoundFlights={setParticipantInboundFlights}
          allParticipantsData={allParticipantsData}
          inputRefs={fieldRefs} // 👈 pass refs here
        />
      </section>
      <section
        id="section6"
        ref={sectionRefs.section6}
        className="px-4 sm:px-10 py-4 bg-headerLight border-b border-sectionBorder"
      >
        <div className="flex gap-2 items-center mb-4">
          <h2>Accommodation Details</h2>
          {isReadOnly && <img src={Lock} alt="lock" width={18} height={18} />}
        </div>
        <AccommodationDetails
          setFormErrors={setFormErrors}
          showPopup={showPopup}
          formData={formData}
          handleChange={handleChange}
          formErrors={formErrors}
          isInvited={isInvited}
          onKnownUserChange={onKnownUserChange}
          onCategoryChange={onCategoryChange}
          allParticipantsData={allParticipantsData}
          inputRefs={fieldRefs}
          inviteFormData={inviteFormData}
          setInviteFormData={setInviteFormData}
        />
      </section>
    </div>
  );
}
